function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable no-unused-vars */
import React from '../../_snowpack/pkg/react.js';
import { observer } from '../../_snowpack/pkg/mobx-react-lite.js';
import { useQuery } from '../../_snowpack/pkg/react-query.js';
import { useTable } from '../../_snowpack/pkg/react-table.js';
import api from '../api/index.js';
import { store, useStore } from '../stores/index.js';
import { formatCurrency, formatDate } from '../utils/utils.js';
import OrderForm from './OrderForm.js';
import Pagination from './Pagination.js';
import { jsx as __cssprop } from "../../_snowpack/pkg/@emotion/react.js";
export default observer(function ReactTable() {
  const store = useStore();
  const columns = React.useMemo(() => [{
    Header: 'ACC',
    accessor: 'account',
    id: 'account',
    isSorted: true
  }, {
    Header: 'Order #',
    id: 'orderNumber',
    accessor: 'orderNumber',
    isSorted: true
  }, {
    Header: 'Order Date',
    id: 'orderDate',
    accessor: row => formatDate(row.orderDate),
    isSorted: true
  }, {
    Header: 'Ship By',
    accessor: row => formatDate(row.shipByDate),
    id: 'shipByDate',
    isSorted: true
  }, {
    Header: 'Status',
    accessor: 'status',
    id: 'status',
    isSorted: true
  }, {
    Header: 'Total',
    id: 'orderTotal',
    accessor: row => __cssprop("div", {
      css: {
        "textAlign": "right"
      }
    }, formatCurrency(row.orderTotal)),
    isSorted: true
  }, {
    Header: 'Tags',
    accessor: row => __cssprop(CellTags, {
      row: row
    })
  }, {
    Header: 'Notes',
    accessor: row => __cssprop(CellNotes, {
      row: row
    }),
    classname: 'cell-notes'
  }], []);
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch
  } = useQuery(['orders', store.getFilter()], () => api.getOrders(store.getFilter()), {
    enabled: store.enableQuery
  });
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    rows,
    visibleColumns
  } = useTable({
    columns,
    data: data?.items || []
  });
  const selectRow = row => {
    store.setSelectedOrderId(row.original.id);
  };
  const handleSort = column => {
    if (!column.isSorted || !store.enableQuery) return;
    store.setSortBy(column.id);
  };
  return __cssprop("div", {
    css: {
      "marginTop": "1rem"
    }
  }, __cssprop("div", {
    css: [{
      "display": "flex",
      "justifyContent": "center",
      "visibility": "hidden"
    }, (isLoading || isFetching) && {
      "visibility": "visible !important"
    }]
  }, __cssprop("span", {
    css: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(37, 99, 235, var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
      "paddingLeft": "1rem",
      "paddingRight": "1rem",
      "paddingTop": "0.25rem",
      "paddingBottom": "0.25rem",
      "borderRadius": "0.25rem",
      "marginBottom": "0.25rem"
    }
  }, "Loading...")), isError && __cssprop("div", {
    css: {
      "--tw-text-opacity": "1",
      "color": "rgba(220, 38, 38, var(--tw-text-opacity))"
    }
  }, error), __cssprop("table", _extends({
    id: "ts-table",
    className: "table table-bordered table-striped",
    css: {
      "marginBottom": "0px"
    }
  }, getTableProps()), __cssprop("thead", null, headerGroups.map(headerGroup => __cssprop("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(column => __cssprop("th", _extends({}, column.getHeaderProps(), {
    css: [column.isSorted && {
      "cursor": "pointer",
      ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(243, 244, 246, var(--tw-bg-opacity))"
      }
    }],
    onClick: () => handleSort(column)
  }), __cssprop("div", {
    css: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "center"
    }
  }, __cssprop("div", null, column.render('Header')), column.isSorted && store.sortBy === column.id && __cssprop("div", {
    css: {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "flex-start"
    }
  }, __cssprop("i", {
    className: "glyphicon glyphicon-triangle-top",
    css: [{
      "height": "1rem"
    }, store.descending && {
      "--tw-text-opacity": "1",
      "color": "rgba(229, 231, 235, var(--tw-text-opacity))"
    }]
  }), __cssprop("i", {
    className: "glyphicon glyphicon-triangle-bottom",
    css: [!store.descending && {
      "--tw-text-opacity": "1",
      "color": "rgba(229, 231, 235, var(--tw-text-opacity))"
    }]
  })))))))), __cssprop("tbody", getTableBodyProps(), rows.map(row => {
    prepareRow(row);
    const rowProps = row.getRowProps();
    const isSelected = row.original.id === store.selectedOrderId;
    const lastSelected = row.original.id === store.lastSelectedOrderId;
    return __cssprop(React.Fragment, {
      key: rowProps.key
    }, __cssprop("tr", _extends({}, rowProps, {
      onClick: () => selectRow(row),
      className: isSelected || lastSelected ? 'selected' : '',
      css: [!isSelected && {
        ":hover": {
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgba(243, 244, 246, var(--tw-bg-opacity))"
        }
      }]
    }), row.cells.map(cell => {
      return __cssprop("td", cell.getCellProps({
        className: cell.column.classname
      }), cell.render('Cell'));
    })), isSelected && renderOrderForm({
      row,
      rowProps,
      visibleColumns,
      data
    }));
  }))), __cssprop(Pagination, {
    data: data,
    onRefresh: () => refetch()
  }));
});
const CellTags = ({
  row
}) => {
  return __cssprop(React.Fragment, null, (row.tags ?? []).map(item => __cssprop("span", {
    key: item.id,
    css: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(37, 99, 235, var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
      "marginRight": "0.5rem",
      "borderRadius": "0.25rem",
      "paddingTop": "0.25rem",
      "paddingBottom": "0.25rem",
      "paddingLeft": "0.5rem",
      "paddingRight": "0.5rem"
    }
  }, item.name)));
};
const CellNotes = ({
  row
}) => {
  return __cssprop(React.Fragment, null, (row.orderNotes ?? []).map(item => __cssprop("div", {
    key: item.id,
    css: {
      "display": "block",
      "textOverflow": "ellipsis",
      "overflow": "hidden",
      "whiteSpace": "pre"
    }
  }, item.note)));
};
function renderOrderForm({
  row,
  visibleColumns
}) {
  return __cssprop("tr", null, __cssprop("td", {
    colSpan: visibleColumns.length,
    css: {
      "padding": "0px !important"
    }
  }, __cssprop(OrderForm, {
    orderId: row.original.id,
    onCancel: () => store.setSelectedOrderId(null)
  })));
}